import { Stack, Typography, Tooltip } from '@mui/material'

export default function ClientHeaderCard({
  icon,
  label,
  value,
  labelColor = '#FF8A3D',
  valueColor = '#50739A',
  maxWidth
}) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        maxWidth,
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }}
    >
      {icon}

      {label && (
        <Typography
          variant="caption"
          fontWeight={600}
          sx={{ color: labelColor, flexShrink: 0 }}
        >
          {label}
        </Typography>
      )}

      <Tooltip title={value} arrow placement="top">
        <Typography
          variant="caption"
          fontWeight={600}
          sx={{
            color: valueColor,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            cursor: 'default'
          }}
        >
          {value}
        </Typography>
      </Tooltip>
    </Stack>
  )
}
